module.exports = __webpack_public_path__ + "static/logoplay-0514559928311d567559f12b68edaca9.png";